import ActionType from './actionType';

export const setReadOnlyMode = (isReadOnlyMode) => ({
  type: ActionType.SET_READ_ONLY_MODE,
  payload: { isReadOnlyMode },
});

export const setExternalAccessMode = (isExternalAccessMode) => ({
  type: ActionType.SET_EXTERNAL_ACCESS_MODE,
  payload: { isExternalAccessMode },
});

export const setLanguage = (language) => ({
  type: ActionType.SET_LANGUAGE,
  payload: { language },
});